import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAddressCompleteGuard } from '@gk/gk-modules';
import { CompositeGuard } from '../../guards/composite/composite.guard';
import { RequestInProgressGuard } from '../../guards/request-in-progress/request-in-progress.guard';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRoutes } from './../../guards/guard.models';
import { MainRequestsListComponent } from './../../shared/main-requests-list/main-requests-list.component';
import { MonumentConservationGrantRequestComponent } from './monument-conservation-grant-request.component';
import { MCGRNewRequestComponent } from './new-request/new-request.component';

const monumentConservationGrantRequestRoutes: Routes = [
  {
    path: MainRoutes.MonumentConservationGrantRequest,
    component: MonumentConservationGrantRequestComponent,
    canActivate: [CompositeGuard],
    data: {
      guards: [SessionGuard, IsAddressCompleteGuard],
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: MCGRNewRequestComponent,
        canDeactivate: [RequestInProgressGuard],
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(monumentConservationGrantRequestRoutes)],
  providers: [
    CompositeGuard,
    SessionGuard,
    RequestInProgressGuard,
    IsAddressCompleteGuard,
  ],
  exports: [RouterModule],
})
export class MonumentConservationGrantRequestRoutingModule {}
